var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('b-container',{attrs:{"fluid":""}},[_c('AppTimer',{staticClass:"timer-date showbox text-center"}),_c('p',[_vm._v("Aiga "+_vm._s(_vm.year)+" | "+_vm._s(_vm.info)+" | "+_vm._s(_vm.cluster))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }